module.exports = __webpack_public_path__ + "img/zaleycash.4c6b5c1d.png";